// Required by CJS deps (for example mapbox-gl-draw-circle -> typed-array-length) in browser runtime.

(window as any).global ??= window;

import('./bootstrap').catch(err => console.error(err));
